import React, { memo } from 'react'
import { IconButton } from '@mui/material'

import { GoogleIcon } from '../../assets/icons/social-icons'

const Google = ({ disabled, onClick }) => {
  return (
    <IconButton color='inherit' onClick={onClick} disabled={disabled}>
      <GoogleIcon width={22} />
    </IconButton>
  )
}

export default memo(Google)
